module.exports = __webpack_public_path__ + "static/media/delete.024b1b0f.svg";